import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '@/utils'
import { component_tool, framework_tool, utils_tool } from '@/tool'
let { WizTypography, WizModal, WizSpin, WizCard, WizAntdForm, WizButton, Wizmessage, WizIcon } = component_tool
let { WizContainer, WizFileUpload } = framework_tool
const { Paragraph } = WizTypography
const { Item } = WizAntdForm
let { excelUtils, Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/interview/question/questionImport') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('interviewQuestionImport', record)
        } else {
            record = Session.get('interviewQuestionImport') || {}
        }
    }
    return record
}

class InterviewQuestionImport extends WizContainer {

    componentName = 'InterviewQuestionImport'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            fileId: undefined,  //上传文件id
            file: undefined,
            fileData: undefined,
            record
        }
        this.itemCol = {
            wrapperCol: {
                xs: { span: 10, offset: 1 },
                sm: { span: 10, offset: 1 }
            },
            labelCol: {
                xs: { span: 5, offset: 0 },
                sm: { span: 5, offset: 0 }
            }
        }
    }

    _interviewQuestionImportOnChange(nextProps, nextState) {
        let o = nextProps['interviewQuestionImport']
        if (o['success']) {
            WizModal.success({ title: '导入成功' })
            this.jumpPage('replace', '/interview/question')
            return true
        } else {
            wizNotice.error(o.msg)
            return false
        }
    }

    propsAndStateOnChange = {
        interviewQuestionImport: this._interviewQuestionImportOnChange.bind(this)
    }

    convertTreeData(fileData) {
        let treeData = []
        if (fileData) {
            let parser = new DOMParser()
            let doc = parser.parseFromString(fileData[0], 'text/xml')
            let array = doc.getElementsByTagName('tr')
            let keyArr = [
                'chapterName',
                'questionName',
                'optionA',
                'optionAType',
                'optionB',
                'optionBType'
            ]
            let count = keyArr.length
            for (let i = 0; i < array.length; i++) {
                let tds = array[i].children
                if (i === 0) {
                    if (keyArr.length !== tds.length) {
                        return false
                    }
                } else {
                    if (tds.length < count) {
                        let data = {}
                        let num = count - tds.length
                        for (let j = count - 1; j >= num; j--) {
                            let element = tds[j - num]
                            let key = keyArr[j]
                            data[key] = element.innerHTML
                        }
                        let arr = treeData
                        for (let k = 1; k <= count - tds.length; k++) {
                            arr = arr[arr.length - 1].questions
                        }
                        arr.push(data)
                    } else {
                        let data = {}
                        for (let j = count - 1; j >= 0; j--) {
                            let element = tds[j]
                            let key = keyArr[j]
                            if (j === 0) {
                                data = { chapterName: element.innerHTML, questions: [data] }
                            } else {
                                data[key] = element.innerHTML
                            }
                        }
                        treeData.push(data)
                    }
                }
            }
        }
        return treeData
    }

    _submitBtn() {
        let { fileId } = this.state
        if (fileId) {
            return (
                <Item label={' '} colon={false} {...this.itemCol}>
                    <WizButton type='primary' onClick={this._submit.bind(this)}>上 传</WizButton>
                </Item>
            )
        }
    }

    _ossBeforeUpload(file) {
        let result = true
        if (file.type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') == -1) {
            Wizmessage.error('只能上传xlsx文件,请重新选择!')
            result = false
        }
        this.setState({ fileId: undefined, file: file }, () => {
            excelUtils.importExcel(
                { target: { files: [file] } },
                (fileData) => this.setState({ fileData: fileData }),
                { dataFun: ['sheet_to_html'] }
            )
        })
        return result
    }

    onChange(file) {
        if (file && file[0]) {
            this.setState({
                fileId: file[0].fileId,
                file: file[0]
            })
        }
    }

    _submit() {
        let { fileId, fileData, record } = this.state
        let { id } = record
        let treeData = this.convertTreeData(fileData)
        this.doAction({
            path: 'interviewQuestion/import',
            payload: {
                key: 'interviewQuestionImport',
                apiParams: {
                    mbtiChapterCmds: treeData,
                    fileId,
                    examId: id
                }
            }
        })
    }

    _fileChildren() {
        let icon = <WizIcon type='loading' style={{ fontSize: 14 }} />
        let fileName = ''
        if (this.state.file && this.state.file.fileOriginalName) {
            icon = <WizIcon type='paper-clip' />
            fileName = this.state.file.fileOriginalName
        } else if (this.state.file && this.state.file.name) {
            fileName = this.state.file.name
        }

        return (
            <>
                <WizButton>
                    <WizIcon type='upload' /> 选择文件
                </WizButton>
                {
                    this.state.file ?
                        <div class='ant-upload-list ant-upload-list-text'>
                            <div class='ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text'>
                                <div class='ant-upload-list-item-info'>
                                    {icon}
                                    <span class='ant-upload-list-item-name ant-upload-list-item-name-icon-count-2'> {fileName} </span>
                                </div>
                            </div>
                        </div> :
                        <></>
                }
            </>
        )
    }


    _render() {
        let { interviewQuestionLoading } = this.props

        let infoProps = {
            title: '导入说明',
            text: [
                <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
                <Paragraph>2、按照要求格式填写信息</Paragraph>,
                <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
            ]
        }
        let operateProps = {
            title: '试题上传',
            template: {
                label: '模版下载',
                fileName: '模版.xlsx',
                href: constants.files.excel_interviewQuestionTemplate
            },
            upload: {}
        }

        return (
            <WizSpin tip={'文件上传中'} spinning={interviewQuestionLoading}>
                <WizCard title={infoProps.title} icon='0'> {infoProps.text}</WizCard>
                <WizCard title={operateProps.title} icon='0'>
                    <Item label={operateProps.template.label} {...this.itemCol}>
                        <a download={operateProps.template.fileName} href={operateProps.template.href}>{operateProps.template.fileName}</a>
                    </Item>
                    <Item label={'选择文件'} {...this.itemCol}>
                        <WizFileUpload
                            accept={'.xlsx'} //, .xls
                            beforeUpload={this._ossBeforeUpload.bind(this)}
                            onChange={this.onChange.bind(this)}
                            children={this._fileChildren()}
                            showUploadList={false}
                            uploadType={'system'}
                        />
                    </Item>
                    {this._submitBtn()}
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { interviewQuestion } = state
    const interviewQuestionImport = modelUtils.getModelEntity(interviewQuestion, 'interviewQuestionImport')
    const loading = modelUtils.getLoadingState(state, 'interviewQuestion')
    return {
        interviewQuestionImport,
        ...loading
    }
}

export default connect(mapStateToProps)(InterviewQuestionImport)
